import {
  buildScenarioItemFiltersQueryString,
  type ScenarioItemFilters,
} from '@/lib/api/adaptive-planner/scenarioItemFilters';
import { tempoApi } from '@/lib/api/tempoApi';
import type {
  BulkFetchTimelineItem,
  TimeLineDataSet,
} from '@/lib/api/types/loop-planner/timeline-item';

const getDataSet = async ({
  loopId,
  scenarioId,
  filters,
}: {
  loopId: number;
  scenarioId: number;
  filters?: ScenarioItemFilters;
}) => {
  const response = await tempoApi()
    .get(
      `api/v1/adaptive-planner/loops/${loopId}/scenarios/${scenarioId}/timeline-items/data-set${buildScenarioItemFiltersQueryString(filters)}`,
    )
    .json<TimeLineDataSet[]>();
  return response;
};

const getCount = async ({
  loopId,
  scenarioId,
  filters,
}: {
  loopId: number;
  scenarioId: number;
  filters?: ScenarioItemFilters;
}) => {
  const response = await tempoApi()
    .get(
      `api/v1/adaptive-planner/loops/${loopId}/scenarios/${scenarioId}/timeline-items/count${buildScenarioItemFiltersQueryString(filters)}`,
    )
    .json<number>();
  return response;
};

const bulkFetch = async ({
  loopId,
  scenarioId,
  itemIds,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
}) => {
  const response = await tempoApi()
    .post(
      `api/v1/adaptive-planner/loops/${loopId}/scenarios/${scenarioId}/timeline-items/bulk-fetch`,
      { json: itemIds },
    )
    .json<BulkFetchTimelineItem[]>();
  return response;
};

export const LoopPlannerTimelineItemsApi = {
  getDataSet,
  getCount,
  bulkFetch,
} as const;
